import Axios from "axios";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/log"

export default class BackendLogger {

  /* eslint-disable no-console */
  static log(level, message) {
    if (process.env.VUE_APP_BACKEND_LOGGING === 'active') {
      let formData = new FormData();
      formData.append("message", message);
      return Axios.post(API_URL + "/" + level, formData)
    } else {
      if (level == 'error') {
        console.error(message);
      } else if (level == 'warn') {
        console.warn(message);
      } else {
        console.log(message);
      }
    }
  }
  /* eslint-enable no-console */

  static debug(message) {
    this.log("debug", message);
  }

  static info(message) {
    this.log("info", message);
  }

  static warn(message) {
    this.log("warn", message);
  }

  static error(message) {
    this.log("error", message);
  }
}


